<div class="qr-term">
    <h1>{{termsAndConditionsText}}</h1>
    <p>{{scanBarcodeText}} </p>
    <div class="qr-code">
        <ngx-qrcode [elementType]="elementType" [errorCorrectionLevel]="correctionLevel" [value]="value"
             [width]="300">
        </ngx-qrcode>
    </div>
    <button class="back-btn" (click)="dismiss()">{{backBtnText | uppercase}}</button>
</div>